<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="სად დავაგროვო"
            data-toggle="modal"
            data-target="#addEditModal"
            data-backdrop="static"
            data-keyboard="false"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <!-- დამატება/რედაქტირება -->
    <div
      class="modal fade bd-example-modal-lg"
      id="addEditModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პარტნიორის დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div id="tabsJustifiedContent" class="tab-content">
                  <div
                    id="main"
                    class="tab-pane fade active show"
                  >
                    <div class="row">
                      <form class="col-12 col-md-6">
                        <div class="form-group">
                          <div class="form-label-group">
                            <input
                              type="text"
                              id="nameWTC"
                              class="form-control"
                              placeholder="კომპანიის დასახელება"
                              autofocus="autofocus"
                              v-model="partner.Name"
                              v-on:input="$v.partner.$touch"
                              v-bind:class="{
                                'error-border': $v.partner.Name.$error,
                                valid:
                                  $v.partner.Name.$dirty &&
                                  !$v.partner.Name.$invalid,
                              }"
                            />
                            <label for="nameWTC">კომპანიის დასახელება</label>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="form-label-group">
                            <input
                              type="text"
                              id="descriptionWTC"
                              class="form-control"
                              placeholder="კომპანიის სამუშაო პროფილი"
                              v-model="partner.Description"
                              v-on:input="$v.partner.$touch"
                              v-bind:class="{
                                'error-border': $v.partner.Description.$error,
                                valid:
                                  $v.partner.Description.$dirty &&
                                  !$v.partner.Description.$invalid,
                              }"
                            />
                            <label for="descriptionWTC">კომპანიის სამუშაო პროფილი</label>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="form-label-group">
                            <input
                              type="text"
                              id="addressWTC"
                              class="form-control"
                              placeholder="მისამართი"
                              v-model="partner.Address"
                              v-on:input="$v.partner.$touch"
                              v-bind:class="{
                                'error-border': $v.partner.Address.$error,
                                valid:
                                  $v.partner.Address.$dirty &&
                                  !$v.partner.Address.$invalid,
                              }"
                            />
                            <label for="addressWTC">მისამართი</label>
                          </div>
                        </div>
                      </form>
                      <form class="col-12 col-md-6">
                        <div class="form-group">
                          <!-- სურათი -->
                          <div class="row">
                            <form class="col-6">
                              <div class="form-label-group">
                                <!---->
                                <form method="post" class="mt-3">
                                  <div class="custom-file">
                                    <input
                                      type="file"
                                      ref="fileGallery"
                                      @change="onFileSelectedGallery"
                                      class="custom-file-input"
                                      id="validatedCustomFileGallery"
                                      :key="fileInputKey"
                                    />
                                    <label
                                      class="custom-file-label"
                                      for="validatedCustomFileGallery"
                                      >ლოგო</label
                                    >
                                  </div>
                                </form>
                                <!---->
                              </div>
                            </form>
                          </div>
                          <div v-if="isEdit">
                            <div v-if="partner.Logo != null">
                              <div class="col-6 mt-3 ml-3">
                                <img
                                  width="80px"
                                  class="img-thumbnail"
                                  :src="imageUrl1(partner.Logo)"
                                />
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="partner.Logo != null">
                              <div
                                v-for="(image, key) in application.documents"
                                :key="image.name"
                              >
                                <div class="row">
                                  <div class="col-6 mt-3">
                                    <img
                                      width="80px"
                                      class="img-thumbnail"
                                      v-bind:ref="'image' + parseInt(key)"
                                      v-bind:src="imagePreviews[parseInt(key)]"
                                      name="asd111"
                                    />
                                  </div>
                                  <div class="col-3 mt-3">
                                    <i
                                      class="fas fa-times deleteBtn"
                                      title="წაშლა"
                                      @click="removeFileFormList(image.name)"
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isEdit"
              type="button"
              class="btn btn-success"
              :disabled="!$v.partner.$dirty || $v.partner.$error"
              @click="$v.partner.$touch(), addPartner()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isEdit"
              type="button"
              class="btn btn-success"
              @click="$v.partner.$touch(), editPartner()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">დასახელება</th>
            <th class="numeric">კურსი</th>
          </tr>
        </thead>
        <tbody>
          <tr class="heading" v-for="value in partnersArray" :key="value.id">
            <td data-title="დასახელება" class="numeric">{{ value.name }}</td>
            <td data-title="კურსი" class="numeric">{{ value.rate }}</td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#addEditModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="editFillInputs(value), modalPrepareEdit()"
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#deleteModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="getDeleteId(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="deleteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deletePartner()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";
import { imageURL } from "../../settings/settings.js";

export default {
  name: "partner",
  data() {
    return {
      partner: {
        Id: null,
        Name: "",
        Address: "",
        Description: "",
        Logo: null,
      },
      isEdit: false,
      partnersArray: [],
    };
  },
  validations: {
    partner: {
      Name: {
        required,
      },
      Address: {
        required,
      },
      Description: {
        required,
      },
      Logo: {
        required,
      },
    },
  },
  async created() {
    let result = await this.$http.getPartnersInfo();
    this.partnersArray = result.data.res;
  },
  methods: {
    async addPartner() {
      try {
        let result = await this.$http.createPartnerInfo(this.partner);
        if (result.data.res.status === "200") {
          this.partner.Id = result.data.res.partnerId;
          await this.onFileSelectedGalleryOnEdit();

          bus.$emit("success", "წარმატებით დაემატა");

          let lst = await this.$http.getPartners();
          this.partnersArray = lst.data.res;
        } else {
          bus.$emit("warning", "დამატების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("warning", "დამატების დროს მოხდა შეცდომა" + error);
      }
    },
    async editPartner() {
      try {
        let result = await this.$http.updatePartnerInfo(this.partner);

        if (result.data.res === "200") {
          bus.$emit("success", "წარმატებით დარედაქტირდა");
          let lst = await this.$http.getPartners();
          this.partnersArray = lst.data.res;
        } else {
          bus.$emit("warning", "რედაქტირების დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deletePartner() {
      try {
        let result = await this.$http.deletePartnerInfo({ id: this.partner.Id });

        if (result.data.res === "200") {
          bus.$emit("success", "წარმატებით წაიშალა");

          let lst = await this.$http.getPartnersInfo();
          this.partnersArray = lst.data.res;
        } else {
          bus.$emit("warning", "წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    getRoleName(id) {
      let index = this.roleArray.findIndex((d) => d.id === id);
      if (index !== -1) {
        return this.roleArray[index].name;
      }
    },
    async editFillInputs(row) {
      this.modalPrepare();
      this.partner.Id = row.id;
      this.partner.Name = row.name;
      this.partner.Description = row.Description;
      this.partner.Logo = row.Logo;
      this.partner.Address = row.Address;
    },
    getDeleteId(id) {
      this.partner.Id = id;
    },
    modalPrepareEdit() {
      this.isEdit = true;
    },
    modalPrepare() {
      this.isEdit = false;
    },
    clearData() {
      this.partner.Id = null;
      this.partner.Name = null;
      this.partner.Description = null;
      this.partner.Logo = null;
      this.partner.Address = null;
    },
    async onFileSelectedGallery() {
      //თუ Edit არის ეგრევე იტვირთება
      if (this.isEdit) {
        await this.onFileSelectedGalleryOnEdit();
      } else {
        //await this.onFileSelectedGalleryOnEdit();
      }
    },
    async onFileSelectedGalleryOnEdit() {
      let data = new FormData();
      data.append("PartnerId", this.partner.Id);
      data.append("Image", this.$refs.fileGallery.files[0]);

      let result = await this.$http.changePartnerImage(data);

      if (result.data.resultCode === "200") {
        bus.$emit("success", "სურათი წარმატებით შეიცვალა");
        location.reload();
      } else {
        bus.$emit("warning", "სურათის ცვლილების დროს მოხდა შეცდომა");
      }
    },
    imageUrl1(mainImageUpuloadName) {
      if (mainImageUpuloadName !== "Choose FIle ...") {
        return imageURL + mainImageUpuloadName;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/WhereToCollect.vue